import styled from 'styled-components';
import { NODE_TEXT_MAX_WIDTH } from '../BaseNode/BaseNode.styles';
import { Box, Text } from '@usealloy/component-library';

export const StyledSnippetIconContainer = styled(Box)`
  background: var(--cl-purple-400);
  border-radius: var(--cl-radius-3);
  padding: var(--cl-space-1);
  width: fit-content;
  margin-right: var(--cl-space-1);
`;

export const StyledLabelText = styled(Text)`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  max-width: calc(${NODE_TEXT_MAX_WIDTH}px - 24px);
`;
